// material-ui
import MuiGlobalStyles from '@mui/material/GlobalStyles';

// project-imports
import { cssVariablesFor } from 'utils/uiTokens';

// ==============================|| THEME - GLOBAL STYLE  ||============================== //

// Los dos juegos de variables se emiten una sola vez y no dependen de ningún estado de
// React. Cambiar de modo solo alterna el atributo `data-clac-mode` del <html>, así que
// el navegador repinta con los valores nuevos sin volver a renderizar el árbol.
const lightVariables = cssVariablesFor('light');
const darkVariables = cssVariablesFor('dark');

export default function GlobalStyles() {
  return (
    <MuiGlobalStyles
      styles={(theme) => ({
        ':root': lightVariables,
        ":root[data-clac-mode='dark']": darkVariables,

        // global-style -> apexcharts
        '.apexcharts-theme-dark .apexcharts-menu': {
          borderColor: theme.palette.text.secondary,
          color: theme.palette.text.primary,
          '& .apexcharts-menu-item:hover': {
            color: theme.palette.primary.main
          }
        }
      })}
    />
  );
}
